import type { UseQueryOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { KEYS, repository } from '@repositories/Repository';
import type ISoftwareCategoryRepository from '@repositories/softwareCategoryRepository/ISoftwareCategoryRepository';
import { SoftwareCategoryListModel } from '@repositories/softwareCategoryRepository/models/SoftwareCategoryListModel';
import type { Filters, SoftwareCategoryListDTO } from '@repositories/softwareCategoryRepository/softwareCategory.types';
import type { Page } from '@type/Page';

const catRepo = repository.get<ISoftwareCategoryRepository>(KEYS.SOFTWARE_CATEGORY_REPOSITORY);
const catQueryKey = {
  all: ['cat'] as const,
  lists: () => [...catQueryKey.all, 'list'] as const,
  list: (filter?: Filters) => [...catQueryKey.lists(), filter] as const,
};

export const useGetCategories = (
  filter?: Filters,
  options?: Omit<
    UseQueryOptions<Page<SoftwareCategoryListDTO>, AxiosError, Page<SoftwareCategoryListModel>>,
    'queryKey' | 'queryFn' | 'select'
  >,
) => {
  const selectCategoryList = useCallback(
    (data: Page<SoftwareCategoryListDTO>) => ({
      ...data,
      content: data.content.map(dto => new SoftwareCategoryListModel(dto)),
    }),
    [],
  );
  return useQuery<Page<SoftwareCategoryListDTO>, AxiosError, Page<SoftwareCategoryListModel>>({
    queryKey: catQueryKey.list(filter),
    queryFn: () => catRepo.getList(filter),
    select: selectCategoryList,
    ...options,
  });
};
